import { Link } from "react-router-dom";
import React from "react";

import {
  FaFacebook,
  FaInstagram,
  FaLinkedinIn,
  FaXTwitter,
  FaYoutube,
} from "react-icons/fa6";

import { Mail, MapPin, Phone, ArrowUp } from "lucide-react";

import logo from "../assets/logo.png";

import "../styles/Footer.css";

import insta from "../assets/inst.jpeg";
import link from "../assets/link.jpeg";
import youtube from "../assets/youtube.jpeg";
import webapp from "../assets/twitter.jpeg";
import face from "../assets/face.jpeg";

const socialLinks = [
  {
    label: "LinkedIn",
    href: "#",
    icon: FaLinkedinIn,
    qr: link,
  },
  {
    label: "Instagram",
    href: "#",
    icon: FaInstagram,
    qr: insta,
  },
  {
    label: "YouTube",
    href: "#",
    icon: FaYoutube,
    qr: youtube,
  },
  {
    label: "Twitter",
    href: "#",
    icon: FaXTwitter,
    qr: webapp,
  },
  {
    label: "FaceBook",
    href: "#",
    icon: FaFacebook,
    qr: face,
  }
];

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer">

      {/* TOP SECTION */}
      <div className="site-footer__top">

        {/* BRAND */}
        <div className="site-footer__brand">

          <Link to="/" className="site-footer__logo">
            <img src={logo} alt="Techlynx Innovations" />

            <span>
              <strong>Techlynx</strong>
              <small>Innovations Pvt Ltd</small>
            </span>
          </Link>

          <p>
            Creative minds building impactful digital experiences. We bring
            strategy, design, and technology together to help businesses turn
            bold ideas into meaningful digital solutions.
          </p>

          <div className="site-footer__brand-contact" aria-label="Contact details">
            <div className="site-footer__contact-item">
              <MapPin aria-hidden="true" />
              <div className="site-footer__office-details">
                <address>
                  <strong>Head Office:</strong>
                  <span>Capital Park, VIP Hills, Silicon Valley, Madhapur, <br/>Hyderabad, Telangana - 500081</span>
                </address>
                <address>
                  <strong>Sub Branches:</strong>
                  <span>Guntur</span>
                </address>
              </div>
            </div>

            <a className="site-footer__contact-item" href="tel:+919989681812">
              <Phone aria-hidden="true" />
              <span>+91 99896 81812</span>
            </a>

            <a className="site-footer__contact-item" href="mailto:info@techlynxinnovations.com">
              <Mail aria-hidden="true" />
              <span>info@techlynxinnovations.com</span>
            </a>
          </div>

        </div>

        {/* SOCIAL MEDIA */}
        <div className="site-footer__social">

          <h2>Social Media</h2>

          <p>
            Don&apos;t miss to follow us on our social networks.
          </p>

          <div className="site-footer__social-scroll">

            {socialLinks.map(
              ({ label, href, icon: Icon, qr }) => (

                <div
                  className="site-footer__social-card"
                  key={label}
                >

                  <a
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={label}
                    className="site-footer__social-icon"
                  >
                    <Icon aria-hidden="true" />
                  </a>

                  <span className="site-footer__social-label">
                    {label}
                  </span>

                  {qr && (
                    <img
                      src={qr}
                      alt={`${label} QR Code`}
                      className="site-footer__qr"
                    />
                  )}

                </div>

              )
            )}

          </div>

        </div>

      </div>

      {/* BOTTOM */}
      <div className="site-footer__bottom">

        <span>
          © 2026 Techlynx Innovations.
          All rights reserved.
        </span>

        <button
          type="button"
          onClick={scrollToTop}
          aria-label="Back to top"
        >
          <ArrowUp aria-hidden="true" />
        </button>

      </div>

    </footer>
  );
}

export default Footer;
